// extracted by mini-css-extract-plugin
export default {"controls":"Slider_controls__Nf4eh","range":"Slider_range__+kDxi"};